/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PatientAllergyApi } from '../api/patientallergy.api';
import { switchMap, map } from 'rxjs/operators';
import { PatientAllergy,PatientAllergyData} from '../../../interfaces/masters/patientAllergy';

@Injectable()
export class PatientAllergyService extends PatientAllergyData {

  constructor(private api: PatientAllergyApi) {
    super();
  }


  list(url: string): Observable<PatientAllergy[]> {
    return this.api.list(url);
  }

  getById(url: string): Observable<PatientAllergy> {
    return this.api.getById(url);
  }

  create(url: string, data: PatientAllergy): Observable<PatientAllergy> {
    return this.api.add(url, data);
  }

  update(url: string, data: PatientAllergy): Observable<PatientAllergy> {
    return this.api.update(url, data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
